import { SM_CONSTANTS } from 'src/app/shared/constants/sm-constants';
import { FcmNotification } from './../../../models/common';
import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ApiService } from 'src/app/providers/api.service';

@Component({
  selector: 'sm-add-target-notification',
  templateUrl: './add-target-notification.component.html',
  styleUrls: ['./add-target-notification.component.scss'],
})
export class AddTargetNotificationComponent implements OnInit {
  public fcmData: FcmNotification = new FcmNotification();
  constructor(
    @Inject(MAT_DIALOG_DATA) public parentData: any,
    private _apiService: ApiService
  ) {}
  ngOnInit(): void {
    this._apiService.apiResult.subscribe((data) => {
      console.log('Data', data);
      if (
        data.responseType === SM_CONSTANTS.SEND_FCM_NOTIFICATION_TO_TOPIC_RESULT
      ) {
        this.parentData.ref.closeAll();
      }
    });
  }
  onPost() {
    console.log(this.fcmData);
    // this.fcmData.topic = 'allUser';
    this._apiService.sendFcmNotificationOnTopic({
      topicInfo: this.fcmData,
    });
  }
}
